const PREFIX = 'calendar-layers:';

export class CalendarLayerPreferences {
  constructor({ storage, key }) {
    this.storage = storage;
    this.key = `${PREFIX}${key}`;
  }

  read() {
    try {
      const value = JSON.parse(this.storage.getItem(this.key));
      return Array.isArray(value) ? [...new Set(value.filter(item => typeof item === 'string'))] : [];
    } catch {
      return [];
    }
  }

  write(slugs) {
    try {
      this.storage.setItem(this.key, JSON.stringify([...new Set(slugs)]));
    } catch {
      // Storage is only an enhancement; the server-rendered GET form remains authoritative.
    }
  }

  restoredUrl(currentUrl, eligibleSlugs) {
    const eligible = new Set(eligibleSlugs);
    const selected = this.read().filter(slug => eligible.has(slug));
    if (selected.length === 0) return null;

    const url = new URL(currentUrl);
    url.searchParams.delete('layers[]');
    selected.forEach(slug => url.searchParams.append('layers[]', slug));
    url.searchParams.set('layers_present', '1');
    return url.toString();
  }
}
